export interface SalesDespatchOrderReport {
  orderNo: number;
  customerOrderNo: string;
  customerOrderRef: string;
}
